export const TRIP_DETAILS_LABELS = [
  { label: "Trip ID", key: "TripID" },
  { label: "Bus Number", key: "BusNo" },
  { label: "User", key: "DriverName" },
  { label: "Branch", key: "BranchName" },
  { label: "Driver Code", key: "DriverCode" },
  { label: "Journey Date", key: "JourneyDate" },
  { label: "Depart Time", key: "DepartureTime" },
  { label: "Print Time", key: "PrintTime" },
  { label: "Route", key: "RouteName" },
  { label: "Booked Bus Seats", key: "TotalSeatsCount" },
  { label: "Bus Booking Amt", key: "TotalFare" },
  { label: "Luggage Total", key: "LuggageAmount" },
  { label: "Concession Total", key: "ConcessionAmount" },
  { label: "Total Amount", key: "TotalAmount" },
];
